module.exports = __webpack_public_path__ + "static/media/warehouse.dc6118d1.png";